var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-item"},[_c('div',{staticClass:"content",class:_vm.typeItem},[_c('div',{staticClass:"badge"}),_c('h4',[_vm._v(" "+_vm._s(_vm.titlebox)+" ")]),_c('p',[_vm._t("default")],2),_c('bouton',{attrs:{"href":_vm.lien}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }